import { datalabHttp } from '@dbl/services/common';
import { AxiosRequestConfig } from 'axios';
import type {
  IYamlBatchOperationParams,
  IYamlBatchOperationResponse,
  IYamlConfigRetrieveDetail,
} from './types';

// 获取过滤选项列表
export function getModelOptions(params: any) {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/yaml-configs/options',
    method: 'post',
    data: params,
  };
  return datalabHttp(options);
}

// 获取表格数据
export function getModelTable(params: any) {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/yaml-configs/list',
    method: 'post',
    data: params,
  };
  return datalabHttp(options);
}

// 保存YAML配置
export function saveYaml(params: any) {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/yaml-configs/save',
    method: 'post',
    data: params,
  };
  return datalabHttp(options);
}

//  检索 YAML 配置
export function getYaml(params: {
  uuid: string;
}): Promise<IYamlConfigRetrieveDetail> {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/yaml-configs/retrieve',
    method: 'post',
    data: params,
  };
  return datalabHttp(options);
}

// 删除 YAML 配置
export function deleteYaml(params: any) {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/yaml-configs/delete',
    method: 'post',
    data: params,
  };
  return datalabHttp(options);
}

// 测试 YAML 配置
export function testYaml(params: IYamlBatchOperationParams): Promise<IYamlBatchOperationResponse> {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/yaml-configs/test',
    method: 'post',
    data: params,
  };
  return datalabHttp(options);
}

// 发布 YAML 配置
export function publishYaml(params: IYamlBatchOperationParams): Promise<IYamlBatchOperationResponse> {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/yaml-configs/publish',
    method: 'post',
    data: params,
  };
  return datalabHttp(options);
}

// 取消发布 YAML 配置
export function unpublishYaml(params: IYamlBatchOperationParams): Promise<IYamlBatchOperationResponse> {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/yaml-configs/unpublish',
    method: 'post',
    data: params,
  };
  return datalabHttp(options);
}

// 生成YAML配置
export function generateYaml(params: any) {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/yaml-configs/generate_yaml',
    method: 'post',
    data: params,
  };
  return datalabHttp(options);
}

// 文件名重名校验
export function checkModelName(params: any) {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/yaml-configs/check_name_exists',
    method: 'post',
    data: params,
  };
  return datalabHttp(options);
}

// 获取表信息(过滤id为空的情况)
export function getGameTableInfoWithoutEmptyIds(params: any) {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/yaml-configs/getGameTableInfo',
    method: 'post',
    data: params,
  };
  return datalabHttp(options);
}